module.exports = __webpack_public_path__ + "media/images/icon__smallInfoBox@3x-c931cf33f1e7b88e30524bc10eb3ba62.png";